<template>
  <div
    class="animate-spin inline-block size-10 border-[3px] border-current border-t-transparent text-indigo-500 rounded-full dark:text-indigo-500"
    role="status"
    aria-label="loading"
  >
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
